var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ParallaxImage",style:({
    height: (_vm.compensatedHeight + "px"),
  })},[_c('ParallaxElement',{staticClass:"ParallaxImage__aspect-ratio-wrap",style:({
      paddingTop: ((_vm.aspectRatio * 100) + "%"),
    }),attrs:{"factor":_vm.compensatedFactor}},[_c('div',{ref:"inside",staticClass:"ParallaxImage__aspect-ratio-inside"},[_vm._t("default")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }